module.exports = __webpack_public_path__ + "static/pricing_yearly-51a0bd158c4ff9724a31a0c795eece16.png";